module.exports = __webpack_public_path__ + "img/list-dropdown-bg.0a9e0c1b.svg";